import React from 'react';
import styled from 'styled-components';

const ThisH1 = styled.h1`
  padding-top: 80px;
  color: white;
  text-align: center;
`;

const ErrorNotFound = () => (
  <div>
    <ThisH1>404</ThisH1>
  </div>
);

export default ErrorNotFound;



// WEBPACK FOOTER //
// ./src/pages/ErrorNotFoundPage.js